export default __webpack_public_path__ + "static/N0117-71f6f227b7c29f93ec02583bdb157942.png";